import { Card, Button, Typography, Row, Col } from "antd";
import CustomIcon from "../icons/CustomIcon";
import styles from './cardList.module.scss';

const { Text } = Typography;
interface Props {
    records: any[],
    handleRowLevelAction: Function,
    blueprint: any,
    deleteMethod: Function,
    openInFieldSearchModal: boolean,
    recordId:string,
}

const CardGrid: React.FC<Props> = ({ records, handleRowLevelAction, blueprint, deleteMethod, openInFieldSearchModal, recordId }) => {


    const cardConfig = blueprint.cardConfig;
    const deleteAction = blueprint.rowLevelactions ? blueprint.rowLevelactions.find((item: any) => item.action === 'delete') : null;

    // console.log(recordId);
    const handleOnClick = (record:any) => {
        console.log(record);
        const customEvent: any = new Event('onSearchFieldSelect');
        const detail = { field: recordId, value: record[recordId] };

        customEvent.detail = detail;
        document.dispatchEvent(customEvent);

    }

    return (
        <Row className="my-4" gutter={[16, 16]}>
            {records.map((item, index) => (
                <Col
                    key={index}
                    xs={24}    // 1 card per row on mobile
                    sm={24}    // 2 cards per row on small screens
                    md={12}     // 3 cards per row on medium screens (tablet)
                    lg={12}     // 4 cards per row on large screens (HD)
                    xl={8}
                    xxl={6}    // 5 cards per row on extra large screens (FHD)
                >
                    <Card hoverable onClick={openInFieldSearchModal ? () => handleOnClick(item) : undefined} bodyStyle={{ padding: "1.2rem" }} className={styles.dataCard + " shadow"}>

                        <div className="flex justify-content-between">
                            <div>
                                <Text className="mb-2 text-lg font-semibold d-block text-primary">
                                    {item[cardConfig.heading] || "Not Available"}
                                </Text>
                            </div>

                            <div>
                                {deleteAction && <Button className="opacity-5" title="Delete" onClick={() => deleteMethod(deleteAction, item)} danger type="link" size="small">
                                    <CustomIcon name="delete" color="#b30000"></CustomIcon>
                                </Button>}
                            </div>
                        </div>

                        <Text className="mb-2 d-block text-base">
                            <span className="text-primary font-medium"> {item[cardConfig.subHeading] || "Not Available"}</span> - <span className="text-secondary">{item[cardConfig.tag] || "Not Available"}</span>
                        </Text>

                        {blueprint.dataGrid.map((columnGrid: any) => {

                            if (columnGrid.hasOwnProperty("display") && columnGrid.display === false) {
                                return null;
                            }

                            if (columnGrid.hasOwnProperty("cardDisplay") && columnGrid.cardDisplay === true) {
                                return null;
                            }

                            if (columnGrid.field === cardConfig.heading || columnGrid.field === cardConfig.subHeading || columnGrid.field === cardConfig.tag) {
                                return null;
                            }

                            return <Text className="mb-2 d-block text-base">
                                <span className="text-primary font-medium">{columnGrid.displayName}: </span>{item[columnGrid.field] || "Not Available"}
                            </Text>

                        })}

                        {!openInFieldSearchModal && <Row gutter={4} justify="end" className="mt-3">
                        
                            {blueprint.rowLevelactions.map((action: any) => {
                                if (action.action === 'delete') {
                                    return null;
                                }
                                return <Col span={12} className="text-right" > <Button variant="outlined" color="primary"  icon={<CustomIcon className="align-top mr-1" name={action.displayName}></CustomIcon>} type="primary" className="mt-2 mt-lg-0 opacity-9" onClick={() => handleRowLevelAction(action, item)}> <span className="align-middle"> {action.iconToolTip} </span>  </Button> </Col>
                            })}

                        </Row>}

                    </Card>
                </Col>
            ))}
        </Row>
    );
};




export default CardGrid;
